/**
 * @module app.shared
 */

import { autoinject, transient } from 'aurelia-framework';
import { Api } from 'app/shared/lib/api/api';
import { AppSession } from 'app/shared/lib/session/session';
import { IApiActionResults } from 'app/shared/lib/api/api-types';
import { AppLogger } from 'app/shared/lib/logging/app-logger';
import * as Core from 'app/core/models/essette-api';
import { EnvironmentService } from 'app/shared/services/environment-service';


@autoinject()
@transient()
export class LogService {

    ////****************** Fields and Properties ************************************////


    ////****************** Functions ************************************************////
    constructor(
        private readonly env: EnvironmentService,
        private readonly api: Api,
        private readonly session: AppSession,
        private readonly logger: AppLogger) {

        this.logger.source = this;
    }


    ////****************** Settings *************************************************////
    public isRemoteLoggingAvailable(): boolean {
        // Remote Logging is Only Available if the User Has Logged into The App
        // and the session is not locked. Otherwise the API call will fail.
        return !!(
            this.env.application.id &&
            this.session.isLoggedIn() &&
            this.session.isCheckedIn() &&
            !this.session.isLocked()
        );
    }

    ////****************** Queries **************************************************////



    ////****************** Loads ****************************************************////


    ////****************** Actions **************************************************////
    public async insertLogs(application: Core.Application): Promise<IApiActionResults> {
        const action = this.api.action('log', `applications/${application.id}`, application);
        return await this.api.post(action);
    }


}
